import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import TemplateDetail from '../emails/TemplateDetail';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import CustomLoader from '../../common/CustomLoader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import { checkSnippetSnapPermission } from '../../home/app_util';
import { SNIPPET_TYPES } from 'drapcode-constant';

export class SnippetTemplateTab extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = {
    snippetsBySearch: [],
    searchKey: '',
    showLoader: false,
    expandedSections: [SNIPPET_TYPES.SNIPPET],
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { editor, currentPageId, actions } = this.props;
    // const { showBuilderCanvasLoader } = editor || '';
    // ?INFO: -> Commented code below to disable Builder Loader Screen
    if (nextProps.currentPageId !== currentPageId) {
      // if (!showBuilderCanvasLoader) {
      // actions.showBuilderLoader();
      //}
      actions.loadSnippets({ projectId: nextProps.projectId, version: nextProps.version });
      actions.loadSnippetSnapshots({ projectId: nextProps.projectId, version: nextProps.version });
    }
    return true;
  }

  componentDidMount() {
    const { projectId, version, actions } = this.props;
    if (projectId) {
      actions.loadSnippets({ projectId, version });
      actions.loadSnippetSnapshots({ projectId, version });
    }
  }

  handleRefresh() {
    const { projectId, version, actions } = this.props;
    if (projectId) {
      this.setState({ showLoader: true });
      actions.loadSnippets({ projectId, version }).then(() => this.setState({ showLoader: false }));
    }
  }

  filterSnippetsBySearch = (event) => {
    const { value } = event.target;
    const { snippets } = this.props.editor;
    const snippetsBySearch = findBySearchString('name', value, snippets);
    let expandedSections = [];
    if (value.length > 0) {
      if (snippetsBySearch.some((item) => item.snippetType === SNIPPET_TYPES.SNIPPET))
        expandedSections.push(SNIPPET_TYPES.SNIPPET);
      if (snippetsBySearch.some((item) => item.snippetType === SNIPPET_TYPES.MODAL))
        expandedSections.push(SNIPPET_TYPES.MODAL);
      if (snippetsBySearch.some((item) => item.snippetType === SNIPPET_TYPES.FLOATING_MODAL))
        expandedSections.push(SNIPPET_TYPES.FLOATING_MODAL);
      if (snippetsBySearch.some((item) => item.snippetType === SNIPPET_TYPES.CUSTOM_SEGMENT))
        expandedSections.push(SNIPPET_TYPES.CUSTOM_SEGMENT);
      if (snippetsBySearch.some((item) => item.snippetType === SNIPPET_TYPES.SUB_PAGE))
        expandedSections.push(SNIPPET_TYPES.SUB_PAGE);
      if (snippetsBySearch.some((item) => item.snippetType === SNIPPET_TYPES.PDF_TEMPLATE))
        expandedSections.push(SNIPPET_TYPES.PDF_TEMPLATE);
      if (snippetsBySearch.some((item) => item.snippetType === SNIPPET_TYPES.PAGE_LAYOUT))
        expandedSections.push(SNIPPET_TYPES.PAGE_LAYOUT);
    } else {
      expandedSections = [SNIPPET_TYPES.SNIPPET];
    }

    this.setState({ snippetsBySearch, searchKey: value, expandedSections });
  };

  showSnippetList = (snippets, snippetType) => {
    const { currentPageId, projectId, version, actions } = this.props;
    const snippetList = snippets.filter((template) => template.snippetType === snippetType);
    return snippetList.map((template) => (
      <TemplateDetail
        key={template.uuid}
        name={template.name}
        uuid={template.uuid}
        template={template}
        toggleEmailSetting={actions.toggleEmailSetting}
        uri="snippets"
        currentPageId={currentPageId}
        projectId={projectId}
        version={version}
        snippetType={template.snippetType}
      />
    ));
  };

  renderAccordionContent = (item) => {
    const { showLoader } = this.state;
    const { snippets } = this.props.editor;

    return (
      <>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-devices-c"></div>
          {this.state.searchKey.length > 0 ? (
            this.showSnippetList(this.state.snippetsBySearch, item.key).length > 0 ? (
              this.showSnippetList(this.state.snippetsBySearch, item.key)
            ) : (
              <p style={{ fontSize: '14px', margin: '0 0 10px' }}>
                No {item.title} matching your search.
              </p>
            )
          ) : snippets && snippets.length > 0 ? (
            showLoader ? (
              <CustomLoader loading={showLoader} />
            ) : this.showSnippetList(snippets, item.key).length > 0 ? (
              this.showSnippetList(snippets, item.key)
            ) : (
              <p style={{ fontSize: '14px', margin: '0 0 10px' }}>No {item.title}.</p>
            )
          ) : (
            <p style={{ fontSize: '14px', margin: '0 0 10px' }}>No {item.title}.</p>
          )}
        </div>
      </>
    );
  };

  renderAccordion = () => {
    const accordionItems = [
      { title: 'Snippet', key: SNIPPET_TYPES.SNIPPET },
      { title: 'Modal', key: SNIPPET_TYPES.MODAL },
      { title: 'Floating Modal', key: SNIPPET_TYPES.FLOATING_MODAL },
      { title: 'Custom Segment', key: SNIPPET_TYPES.CUSTOM_SEGMENT },
      { title: 'Sub Page', key: SNIPPET_TYPES.SUB_PAGE },
      { title: 'PDF Template', key: SNIPPET_TYPES.PDF_TEMPLATE },
      { title: 'Page Layout', key: SNIPPET_TYPES.PAGE_LAYOUT },
    ];

    return accordionItems.map((item) => (
      <AccordionItem key={item.key} uuid={item.key}>
        <AccordionItemState>
          {({ expanded }) => (
            <>
              <AccordionItemHeading className="gjs-block-category">
                <AccordionItemButton className="gjs-title">
                  <span
                    className={
                      expanded
                        ? 'gjs-caret-icon fa fa-caret-down'
                        : 'gjs-caret-icon fa fa-caret-right'
                    }
                  ></span>
                  &nbsp;
                  {item.title}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>{this.renderAccordionContent(item)}</AccordionItemPanel>
            </>
          )}
        </AccordionItemState>
      </AccordionItem>
    ));
  };
  render() {
    const { expandedSections } = this.state;
    const { isReadOnly } = this.props;
    const isAllow = checkSnippetSnapPermission();
    if (!isAllow) {
      return (
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          To use Snippet Snapshots, please upgrade your plan.{' '}
          <a
            href={`${process.env.REACT_APP_ORGANIZATION}accounts`}
            className="btn btn-sm btn-theme-submit"
          >
            <i className="wb webconnect-paper-plane-fill"></i> Upgrade
          </a>
        </div>
      );
    }
    return (
      <>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Snippet" className="padding-left-20">
              Snippet
            </span>
            <span
              title="Reload Snippets"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Snippets"
                data-place="bottom"
                data-effect="solid"
                onClick={() => this.handleRefresh()}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span title={isReadOnly ? 'Read-only mode' : 'Snippet'}>
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip={isReadOnly ? 'Read-only mode' : 'Create New Template'}
                data-place="bottom"
                data-effect="solid"
                onClick={() => {
                  if (isReadOnly) return;
                  this.props.actions.toggleEmailSetting({ snippet: {} });
                  Mixpanel.track('Clicked on- Add Snippet Button on builder');
                }}
                style={{
                  opacity: isReadOnly ? 0.5 : 1,
                  cursor: isReadOnly ? 'not-allowed' : 'pointer',
                }}
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add Snippet
              </a>
            </span>
          </div>
          <div className="gjs-devices-c"></div>
        </div>

        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-devices-c"></div>
          <div className="form-outline" style={{ padding: '10px' }}>
            <input
              type="search"
              className="form-control form-control-sm"
              placeholder="&#xf55c; Eg: Header"
              style={{ fontFamily: 'Arial, Webconnect' }}
              onChange={this.filterSnippetsBySearch}
            />
          </div>
          <Accordion
            key={expandedSections.join(',')}
            allowZeroExpanded
            preExpanded={expandedSections}
          >
            {this.renderAccordion()}
          </Accordion>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SnippetTemplateTab);
